export const HEADING = "Let's get started with some of the basics";
